import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MobileOnlyLink from '@acorn-portal/shared/src/components-v2/mobile-only-link';

/**
 * @param contactPhoneNumber - The phone number to contact for support.
 * @param autoRenewalOptIn - Whether the auto renewal is opted in.
 * @param expiryDate - The expiry date of the policy.
 * @param isShortTermPolicy - Whether the policy is a short term policy.
 */
interface AutoRenewedBlockedProps {
	contactPhoneNumber: string;
	autoRenewalOptIn: boolean;
	expiryDate: string;
	isShortTermPolicy: boolean;
}

const AutoRenewedBlocked = ({
	contactPhoneNumber,
	autoRenewalOptIn,
	expiryDate,
	isShortTermPolicy,
}: AutoRenewedBlockedProps) => {
	return (
		<Box>
			{!autoRenewalOptIn && (
				<Typography sx={{ mt: 2 }}>
					You have opted out of auto renewal. This means your policy will expire on {expiryDate}.
				</Typography>
			)}
			<Box sx={{ mt: 2, mb: 2 }}>
				<Alert severity='info'>
					You are within the last {isShortTermPolicy ? '7' : '10'} days of your policy renewal period so you won&apos;t
					be able to make any changes online. Please contact us on{' '}
					<MobileOnlyLink href={`tel:${contactPhoneNumber}`} text={contactPhoneNumber} /> if you would like to make a
					change to your renewal preferences.
				</Alert>
			</Box>
			<Typography>
				Please note it is an offence under the Road Traffic Act 1988 to leave, drive or otherwise use your vehicle on a
				public highway without a valid insurance cover being in force, therefore if you do opt out please ensure you
				arrange for alternative cover on expiry of your policy.
			</Typography>
		</Box>
	);
};

export default AutoRenewedBlocked;
